import { PIP_IFRAME_NAME } from './constants'

/**
 * Test if current script runs in a PIP iframe. This check should have no
 * dependencies.
 */
export function isInPIPIframe() {
  return (
    typeof window !== 'undefined' &&
    window.frameElement?.getAttribute('name') === PIP_IFRAME_NAME
  )
}
